<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="[
        'Quantidade Chave',
        'Descrição Chave',
        'Indicador Chave',
        'Data Alteração',
        'Data Cadastro',
        'Situação Chave',
        'Tipo Chave'
      ]"
            :showTipFooter="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.quantidadeChavePix ? obj.quantidadeChavePix  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.descricaoChavePix ? obj.descricaoChavePix  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.indicadorChavePix ? obj.indicadorChavePix  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.dataAlteracao ? formatDate(obj.dataAlteracao)  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.dataCadastro ? formatDate(obj.dataCadastro)  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.situacaoChavePix ? obj.situacaoChavePix  : '-'" />
        <TableColumn v-on:Edit="showLead(obj)" :IsText="true" :status="1" :value="obj.descricaoTipoChave ? obj.descricaoTipoChave  : '-'" />
       </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import PixRepository from '@/shared/http/repositories/business/pix.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'pix',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadPix(this.document)
      }
    },
    onLoadPix (document) {
      loading.push()
      this.document = document
      PixRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    showLead (obj) {
      if (obj) {
        const routeData = this.$router.resolve({
          name: 'DetalhesLead',
          params: {
            boardId: obj.boardColumn.board.id,
            cardId: obj.id
          }
        })
        window.open(routeData.href, '_blank')
      }
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/pix.vue